import { render } from "./ProjectsButtons.vue?vue&type=template&id=4f249594"
import script from "./ProjectsButtons.vue?vue&type=script&lang=js"
export * from "./ProjectsButtons.vue?vue&type=script&lang=js"
script.render = render

export default script